export default "ui-menu-column{display:flex;flex-direction:column;align-items:flex-start;align-self:stretch;gap:var(--ui-spacing-xlarge)}\n";